import { defineComponent, createElementBlock, openBlock, createElementVNode, Fragment, renderList, createVNode } from 'vue';
import _sfc_main$1 from './basler-components.es85.js';
/* empty css                       */

const _hoisted_1 = { class: "attributes" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "attribute-name" };
const _hoisted_4 = { class: "attribute-value" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "attribute-name" };
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = { class: "attribute-value" };
const _hoisted_9 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AttributeTable",
  props: {
    attributes: {},
    isLoading: { type: Boolean, default: false },
    loadingLines: { default: 3 }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("table", _hoisted_1, [
        _cache[0] || (_cache[0] = createElementVNode("thead", { class: "visually-hidden" }, [
          createElementVNode("tr", null, [
            createElementVNode("th", null, "Attribute Name"),
            createElementVNode("th", null, "Attribute Value")
          ])
        ], -1)),
        _ctx.isLoading ? (openBlock(), createElementBlock("tbody", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.loadingLines, (index) => {
            return openBlock(), createElementBlock("tr", { key: index }, [
              createElementVNode("td", _hoisted_3, [
                createVNode(_sfc_main$1, { class: "attributes__loading-content" })
              ]),
              createElementVNode("td", _hoisted_4, [
                createVNode(_sfc_main$1, { class: "attributes__loading-content" })
              ])
            ]);
          }), 128))
        ])) : (openBlock(), createElementBlock("tbody", _hoisted_5, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.attributes, (attribute, index) => {
            return openBlock(), createElementBlock("tr", { key: index }, [
              createElementVNode("td", _hoisted_6, [
                createElementVNode("span", {
                  innerHTML: attribute.label
                }, null, 8, _hoisted_7)
              ]),
              createElementVNode("td", _hoisted_8, [
                createElementVNode("span", {
                  innerHTML: attribute.value
                }, null, 8, _hoisted_9)
              ])
            ]);
          }), 128))
        ]))
      ]);
    };
  }
});

export { _sfc_main as default };
